export const nutritionPlan = {
  header: {
    title: 'Your 30-Day Nutrition Plan',
    lastUpdated: 'Last updated: {{date}}',
    downloadPdf: 'Download PDF',
    changePlan: 'Change Plan',
    activatePlan: "Activate Plan",
    noHistoryFound: "No history found",
    active: "Active",
    selectPlan: "Select a Plan",
    historyLockedTitle: 'Plan History',
    historyLockedDescription:
      'Upgrade to VIP to browse and restore previous meal plans.',
  },
  viewMode: {
    calendar: 'Calendar View',
    list: 'List View',
    currentDay: 'Current Day:',
    day: 'Day',
  },
  overview: {
    title: 'Plan Overview',
    basicPlan: 'Basic Plan',
    vipPlan: 'VIP Plan',
    goal: 'Goal:',
    goalValue: 'Weight Loss',
    calorieTarget: 'Calorie Target:',
    calorieValue: '1520 kcal/day',
    meals: 'Meals:',
    mealsValue: '3 per day',
    dietType: 'Diet Type:',
    dietTypeValue: 'Vegetarian',
    allergies: 'Allergies:',
    allergiesValue: 'Lactose',
    activityLevel: 'Activity Level:',
    activityLevelValue: 'Moderate',
    startDate: 'Start Date:',
    startDateValue: 'January 4, 2025',
    endDate: 'End Date:',
    endDateValue: 'February 2, 2025',
    progress: 'Progress:',
    progressValue: '{{current}} of {{total}} days',
    perDay: 'per day',
  },
  calendar: {
    title: '{{duration}}-Day Calendar',
    today: 'Today',
    day: 'Day',
  },
  list: {
    day: 'Day',
    today: 'Today - Day {{day}}',
    dayLabel: 'Day {{day}}',
    mealInfo: '3 meals • 1520 kcal • Click for details',
    completed: 'Completed',
    current: 'Current',
  },
  info: {
    basicTitle: 'Basic Plan Notice',
    basicMessage: 'With the Basic Plan, you get a complete 30-day plan. Changes are only possible after the 30 days expire. Upgrade to VIP for unlimited customizations, detailed recipes, and PDF export!',
    vipTitle: 'VIP Benefits Active',
    vipMessage: 'You can change your plan anytime, view detailed recipes, download PDFs, and create shopping lists. Use the chat for personalized adjustments!',
  },
  recipe: {
    calories: 'Calories',
    kcal: 'kcal',
    nutritionTitle: 'Nutritional Information',
    protein: 'Protein',
    carbs: 'Carbs',
    fat: 'Fat',
    ingredients: 'Ingredients',
    vipFeatureTitle: 'VIP Feature',
    vipFeatureMessage: 'Upgrade to VIP to see detailed ingredients and instructions.',
    servings: 'Servings',
    portions: 'portions',
    totalTime: 'Total Time',
    minutes: 'minutes',
    cuisine: 'Cuisine',
    dishType: 'Dish Type',
    instructions: 'Instructions',
    viewFullRecipe: 'View Full Recipe & Instructions',
    opensInNewTab: 'Opens in new tab at',
    weight: 'Weight',
    addToShoppingList: 'Add to shopping list',
    neverShowIngredient: 'Never show this ingredient',
  },
  mealDetailModal: {
    todayMealPlan: "Day {{dayNumber}} - Your Meal Plan",
    completeOverviewOfMeals: "Complete overview of all meals",
    editDay: "Edit Day",
    noMealsForDay: "No meals found for this day",
    dailySummary: "Daily Summary",
    totalCalories: "Total calories",
    upgradeToVip: "Upgrade to VIP for more features",
    vipFeaturesDescription: "PDF export, shopping lists, detailed recipes and more!",
  },
  noActivePlan: {
    title: "No Active Nutrition Plan",
    subtitle: "You don't have an active nutrition plan yet. Let's create one!",
    cta: "Create My Plan with AI",
    whatYouGet: "What You'll Get",
    mealPlanDuration: "Personalized {{days}}-day meal plan",
    tailored: "Tailored to your goals and dietary preferences",
    detailedRecipes: "Detailed recipes with instructions",
    basicDescriptions: "Basic meal descriptions",
    aiModifications: "AI-powered modifications anytime"
  }
};
